import {
  IconLayoutDashboard,
  IconUsers,
  IconCar,
  IconFileText,
  IconSettings,
  IconPhone,
  IconDeviceDesktop,
  IconSearch,
  IconCalendarEvent,
  IconRocket,
  IconPaperclip,
  IconToolsKitchen2,
  IconHeadset,
  IconShoppingCart,
  IconChartBar,
} from '@tabler/icons-react';

export const availableIcons = [
  { value: 'IconLayoutDashboard', label: 'Dashboard', icon: IconLayoutDashboard },
  { value: 'IconUsers', label: 'Kullanıcılar', icon: IconUsers },
  { value: 'IconCar', label: 'Araç', icon: IconCar },
  { value: 'IconFileText', label: 'Dosya / Evrak', icon: IconFileText },
  { value: 'IconSettings', label: 'Ayarlar', icon: IconSettings },
  { value: 'IconPhone', label: 'Telefon Rehberi', icon: IconPhone },
  { value: 'IconDeviceDesktop', label: 'Bilgisayar / IT', icon: IconDeviceDesktop },
  { value: 'IconSearch', label: 'Arama', icon: IconSearch },
  { value: 'IconCalendarEvent', label: 'Takvim', icon: IconCalendarEvent },
  { value: 'IconRocket', label: 'Roket (Yakında)', icon: IconRocket },
  { value: 'IconPaperclip', label: 'Ek / Bağlantı', icon: IconPaperclip },
  { value: 'IconToolsKitchen2', label: 'Yemekhane', icon: IconToolsKitchen2 },
  { value: 'IconHeadset', label: 'Destek / Kulaklık', icon: IconHeadset },
  { value: 'IconShoppingCart', label: 'Satın Alma', icon: IconShoppingCart },
  { value: 'IconChartBar', label: 'Raporlar', icon: IconChartBar },
];

export const mantineColors = [
  { value: 'blue', label: 'Mavi' },
  { value: 'red', label: 'Kırmızı' },
  { value: 'teal', label: 'Turkuaz' },
  { value: 'cyan', label: 'Açık Mavi' },
  { value: 'orange', label: 'Turuncu' },
  { value: 'violet', label: 'Mor' },
  { value: 'indigo', label: 'Lacivert' },
  { value: 'pink', label: 'Pembe' },
  { value: 'green', label: 'Yeşil' },
  { value: 'yellow', label: 'Sarı' },
  { value: 'dark', label: 'Siyah' },
  { value: 'gray', label: 'Gri' },
];